"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _calendarHelpers = _interopRequireWildcard(require("./calendarHelpers"));

var _elements = require("./elements");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ArrowLeft = (0, _styledComponents["default"])(_elements.CalendarArrow).withConfig({
  displayName: "calendar__ArrowLeft",
  componentId: "sc-1gjmvcr-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &::before {\n        transform: rotate(90deg);\n        margin: 18px 0 0 25px;\n    }\n"])));
var ArrowRight = (0, _styledComponents["default"])(_elements.CalendarArrow).withConfig({
  displayName: "calendar__ArrowRight",
  componentId: "sc-1gjmvcr-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &::before {\n        transform: rotate(270deg);\n        margin: 18px 25px 0 0;\n    }\n"])));

var Calendar = /*#__PURE__*/function (_Component) {
  _inherits(Calendar, _Component);

  var _super = _createSuper(Calendar);

  function Calendar() {
    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      calendarMonth: "".concat(_calendarHelpers.CALENDAR_MONTHS[_calendarHelpers.THIS_MONTH - 1], " ").concat(_calendarHelpers.THIS_YEAR),
      selectedDate: [],
      monthDays: [],
      month: _calendarHelpers.THIS_MONTH,
      year: _calendarHelpers.THIS_YEAR,
      minDate: null,
      maxDate: null
    });

    _defineProperty(_assertThisInitialized(_this), "setCalendarMonth", function () {
      var _this$state = _this.state,
          month = _this$state.month,
          year = _this$state.year;

      _this.setState({
        calendarMonth: "".concat(_calendarHelpers.CALENDAR_MONTHS[month - 1], " ").concat(year)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "init", function () {
      var _this$props = _this.props,
          nowDate = _this$props.nowDate,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;

      if (nowDate) {
        var startDate = (0, _calendarHelpers.getStartArray)(nowDate);

        _this.setState({
          monthDays: (0, _calendarHelpers["default"])(+startDate[1], +startDate[0]),
          selectedDate: startDate,
          month: +startDate[1],
          year: +startDate[0],
          minDate: minDate ? minDate : null,
          maxDate: maxDate ? maxDate : null
        }, function () {
          return _this.setCalendarMonth();
        });
      } else {
        _this.setState({
          monthDays: (0, _calendarHelpers["default"])()
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setPrevMonth", function (e) {
      var _this$state2 = _this.state,
          month = _this$state2.month,
          year = _this$state2.year;
      var date = (0, _calendarHelpers.getPreviousMonth)(month, year);
      e.stopPropagation();

      _this.setState({
        monthDays: (0, _calendarHelpers["default"])(+date.month, +date.year),
        month: +date.month,
        year: +date.year
      }, function () {
        return _this.setCalendarMonth();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setNextMonth", function (e) {
      var _this$state3 = _this.state,
          month = _this$state3.month,
          year = _this$state3.year;
      var date = (0, _calendarHelpers.getNextMonth)(month, year);
      e.stopPropagation();

      _this.setState({
        monthDays: (0, _calendarHelpers["default"])(+date.month, +date.year),
        month: +date.month,
        year: +date.year
      }, function () {
        return _this.setCalendarMonth();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectNumber", function (e, selectedDate, disabled) {
      var onChange = _this.props.onChange;

      if (disabled) {
        e.stopPropagation();
      } else {
        _this.setState({
          selectedDate: selectedDate
        });

        onChange([selectedDate[0], (0, _calendarHelpers.zeroPad)(selectedDate[1], 2), (0, _calendarHelpers.zeroPad)(selectedDate[2], 2)].join('-'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "inInterval", function (item) {
      var _this$props2 = _this.props,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate;
      var itemTempVal = new Date((0, _calendarHelpers.arrToDate)(item));
      var itemDate = itemTempVal.getTime();
      var tempMinValue = minDate ? new Date(minDate) : null;
      var tempMaxValue = maxDate ? new Date(maxDate) : null;
      var minValue = tempMinValue ? tempMinValue.getTime() : null;
      var maxValue = tempMaxValue ? tempMaxValue.getTime() : null;
      if (!minDate && !maxDate) return true;
      if (!minDate && maxDate) return itemDate === maxValue || itemDate < maxValue;
      if (!maxDate && minDate) return itemDate === minValue || itemDate > minValue;
      if (maxDate && minDate) return (itemDate > minValue || itemDate === minValue) && (itemDate < maxValue || itemDate === maxValue);
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "getItems", function (items, start, count, month, now) {
      var selectedDate = _this.state.selectedDate;
      var menuItems = [];
      var selectedDateStr = selectedDate.join('-');

      var _loop = function _loop(i) {
        var item = items[i];
        var disabled = month !== item[1] || !_this.inInterval(item);
        var itemStr = item.join('-');
        menuItems.push( /*#__PURE__*/_react["default"].createElement(_elements.CalendarNumber, {
          key: "item".concat(i),
          onClick: function onClick(e) {
            return _this.selectNumber(e, item, disabled);
          },
          isDisabled: disabled,
          isNow: now[0] === item[0] && now[1] === item[1] && now[2] === item[2],
          isSelected: selectedDateStr === itemStr
        }, item[2]));
      };

      for (var i = start; i < start + count; i++) {
        _loop(i);
      }

      return menuItems;
    });

    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var nowDate = this.props.nowDate;

      if (prevProps.nowDate !== nowDate) {
        this.init();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state4 = this.state,
          calendarMonth = _this$state4.calendarMonth,
          monthDays = _this$state4.monthDays,
          month = _this$state4.month;
      var showCalendar = this.props.showCalendar;

      var weekDays = _calendarHelpers.WEEK_DAYS.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_elements.CalendarDayTitle, {
          key: item
        }, item);
      });

      var lines = [];

      if (monthDays.length > 0) {
        var viewMonth = month || _calendarHelpers.THIS_MONTH;
        var nowDate = new Date();
        var now = [nowDate.getFullYear(), nowDate.getMonth() + 1, nowDate.getDate()];

        for (var i = 0; i < _calendarHelpers.CALENDAR_WEEKS; i++) {
          lines.push( /*#__PURE__*/_react["default"].createElement(_elements.CalendarDayLine, {
            key: "line".concat(i)
          }, this.getItems(monthDays, i * 7, 7, viewMonth, now)));
        }
      }

      return /*#__PURE__*/_react["default"].createElement(_elements.CalendarBody, {
        showCalendar: showCalendar
      }, /*#__PURE__*/_react["default"].createElement(_elements.CalendarHeader, null, /*#__PURE__*/_react["default"].createElement(ArrowLeft, {
        onClick: function onClick(e) {
          return _this2.setPrevMonth(e);
        }
      }), /*#__PURE__*/_react["default"].createElement(_elements.CalendarMonth, null, calendarMonth), /*#__PURE__*/_react["default"].createElement(ArrowRight, {
        onClick: function onClick(e) {
          return _this2.setNextMonth(e);
        }
      })), /*#__PURE__*/_react["default"].createElement(_elements.CalendarDayLine, {
        isFirstLine: true
      }, weekDays), /*#__PURE__*/_react["default"].createElement(_elements.CalendarDayLine, {
        isFirstLine: false
      }, lines));
    }
  }]);

  return Calendar;
}(_react.Component);

var _default = Calendar;
exports["default"] = _default;